import PropTypes from "prop-types";
import {Theme, withStyles} from "@material-ui/core/styles";

const styles = (theme: Theme) => ({
  "@global": {
    body: {
      background: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText
    },
    h3: {
      color: theme.palette.primary.contrastText,
    },
    h6: {
      color: theme.palette.primary.contrastText,
    },
    div: {
      background: theme.palette.primary.dark,
    },
    p: {
      color: theme.palette.primary.contrastText
    }
  }
});

function MyCssBaseline() {
  return null;
}

MyCssBaseline.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MyCssBaseline);
